export default {
  views: {
    details: {
      components: {
        main: {
          index: {
            person: "Fizična oseba",
            company: "Podjetje"
          },
          components: {
            overview: {
              "author": "Ustvaril",
              "created_at": "Ustvarjeno",
              "last_modified": "Nazadnje urejal",
              "updated_at": "Posodobljeno"
            },
            basic: {
              title: "Osebni podatki",
              name: "Ime",
              phone: "Telefonska številka",
              email: "Elektronski naslov",
              address: "Naslov",
              tax_number: "Davčna številka",
              pantheon_name: "Ime v Pantheonu",
              pantheon_id: "ID v Pantheonu"
            }
          }
        },
        header: {
          "back_button": "Seznam strank",
          "edit_button": "Uredi stranko"
        }
      },
      index: {}
    },
    list: {
      components: {
        header: {
          "search": "Iskanje ...",
          "add_customer": "Dodaj stranko"
        }
      },
      index: {
        "open": "Odpri",
        "edit": "Uredi",
        "delete": "Izbriši",
        "an_error_occurred_while_updating_customer": "Med posodabljanjem je prišlo do napake",
        "successfully_updated_customer": "Stranka uspešno posodobljena",
        "remove_customer": "Izbriši stranko",
        "youre_about_to_delete_customer_title_would_you_like_to_proceed_with_this_action": "Ste prepričani, da želite izbrisati stranko {name}?",
        "cancel": "Prekliči",
        "customer_title_successfully_deleted": "Stranka {name} izbrisana",
        "name": "Ime",
        "phone": "Telefonska številka",
        "email": "Elektronski naslov",
        "created_at": "Ustvarjeno",
        "type": "Tip",
        "company": "Podjetje",
        "person": "Fizična oseba"
      }
    }
  }
}
